import translate from '@i18n'
import styled, { css } from 'styled-components'
import { useCallback, useState } from 'react'
import FollowMyTeamSportCompetitorsList from '../FollowMyTeamSelectTeam/FollowMyTeamSportCompetitorsList'
import FollowMyTeamDrawerHeader from '../FollowMyTeamDrawer/Header'
import FollowMyTeamMyTeamsList from './FollowMyTeamMyTeamsList'
import PrimaryCTAButton from '@components/Buttons/PrimaryCTAButton'

const Container = styled.div`
  ${({
    theme: {
      spacing: { spacing16 },
    },
  }) => css`
    display: flex;
    flex-direction: column;
    gap: ${spacing16};
  `}
`

const StyledPrimaryCTAButton = styled(PrimaryCTAButton)`
  ${({
    theme: {
      spacing: { spacing16 },
    },
  }) => css`
    margin: 0 ${spacing16};
    width: calc(100% - (${spacing16} * 2));
  `}
`

const FollowMyTeamMyTeams = ({ onClose }: { onClose: () => void }) => {
  const [showSportCompetitorsList, setShowSportCompetitorsList] =
    useState(false)

  const handleBack = useCallback(() => {
    setShowSportCompetitorsList(false)
  }, [])

  const handleAddTeam = useCallback(() => {
    setShowSportCompetitorsList(true)
  }, [])

  return (
    <Container>
      <FollowMyTeamDrawerHeader
        title={translate(
          showSportCompetitorsList
            ? 'followMyTeam.selectTeam'
            : 'followMyTeam.myTeams'
        )}
        showBackButton={showSportCompetitorsList}
        onBack={handleBack}
        onClose={onClose}
      />

      {showSportCompetitorsList ? (
        <FollowMyTeamSportCompetitorsList />
      ) : (
        <>
          <StyledPrimaryCTAButton
            onClick={handleAddTeam}
            colorVariant="black"
            size="large"
            iconName="plus-circle"
            iconLeft={true}>
            {translate('followMyTeamOverview.addTeam')}
          </StyledPrimaryCTAButton>
          <FollowMyTeamMyTeamsList />
        </>
      )}
    </Container>
  )
}

export default FollowMyTeamMyTeams
